import { NativeModules, Platform, Dimensions, StatusBar } from 'react-native';
import { isAndroid, isWeb } from './device-info';
const { height, width } = Dimensions.get('window');

const SCREEN_WIDTH = Math.min(width, height);
const SCREEN_HEIGHT = Math.max(width, height);
const designSizeMap = {
    vw: 100,
};
let FACTOR = 100;
const VERTICAL = 1334;

const _rem = (num: number | string, key?: string) => {
    if (typeof num === 'number') {
        return Number(((SCREEN_WIDTH / FACTOR) * num).toFixed(1));
    } else if (typeof num === 'string') {
        const reg = /^(-?[0-9]+([\\.]{1}[0-9]+)?)(rpx|lrpx|nrpx|px|vw)$/;
        if (reg.test(num)) {
            const regRes = num.match(reg);

            const number = Number(regRes[1]);
            if (key === 'borderWidth' && number <= 1) {
                return 1;
            }
            const unit = regRes[3];
            FACTOR = designSizeMap[unit];
            return Number(((SCREEN_WIDTH / FACTOR) * number).toFixed(1));
        } else return num;
    }
};
const _remWith = (baseWidth: number, num: number) => {
    return Number(((baseWidth / FACTOR) * num).toFixed(1));
};
/**
 *
 * @param num 414设计稿下的尺寸
 * @returns
 */

export const rem = (num: number) => {
    if (Platform.OS === 'web') {
        return num;
    }
    return _rem(num);
};

export type KidProps = {
    kid?: string;
};

const UnitsOfLength = new Set([
    'diameter',
    'borderWidth',
    'textFont',
    'arrowWidth',
    'arrowHeight',
    'arrowCornerRadius',
    'bubbleOffsetX',
    'bubbleOffsetY',
    'bubbleCornerRadius',
    'width',
    'height',
    'cornerRadius',
    'padding',
    'paddingTop',
    'paddingBottom',
    'paddingLeft',
    'paddingRight',
    'marginTop',
    'marginBottom',
    'marginRight',
    'marginLeft',
    'top',
    'left',
    'right',
    'bottom',
    'maxWidth',
    'lineHeight',
    'minHeight',
    'maxHeight',
    'minWidth',
    'borderRadius',
    'fontSize',
]);
type dataType = Record<string, any | number>;

export function RFValue(fontSize) {
    const { height, width } = Dimensions.get('window');
    const standardLength = SCREEN_HEIGHT;
    const offset = width > height ? 0 : Platform.OS === 'ios' ? 78 : StatusBar.currentHeight; // iPhone X style SafeAreaView size in portrait

    const deviceHeight = Platform.OS === 'android' ? standardLength - offset : VERTICAL;

    const heightPercent = (fontSize * deviceHeight) / VERTICAL;
    return Math.round(heightPercent);
}
/**
 * 长度单位自适应转换
 */
export const conversionUnitOfLength = (data: dataType) => {
    if (Platform.OS === 'web') {
        return data;
    }
    Object.keys(data).forEach((key: string) => {
        if (UnitsOfLength.has(key)) {
            data[key] = _rem(data[key], key);
        }
        // else if (key === 'fontSize') {
        //     data[key] = RFValue(data[key]);
        // }
    });
    return data;
};
export const convertStyles = (styles: dataType) => {
    // eslint-disable-next-line prefer-const
    let styleObj = { ...styles };
    const result = Object.keys(styleObj).reduce((prev, styleKey) => {
        return Object.assign({}, prev, {
            [styleKey]: conversionUnitOfLength(styleObj[styleKey]),
        });
    }, {});
    // console.log('result: ', result);
    return styleObj;
};

export const covertRtlStyles = (styles: dataType) => {
    const n = convertStyles(styles);
    return {
        Styles: n,
        rtlClassName: (name: string | string[]) => {
            if (Array.isArray(name)) {
                const result = [
                    name.map((className) => {
                        return n[className];
                    }),
                    name.map((className) => {
                        return n[`${className}-rtl`];
                    }),
                ];
                return result;
            } else {
                return [n[name], n[`${name}-rtl`]];
            }
        },
    };
};
const rtlCovertAttrs = {
    left: 'right',
    right: 'left',
    paddingLeft: 'paddingRight',
    paddingRight: 'paddingLeft',
    marginLeft: 'marginRight',
    marginRight: 'marginLeft',
};
export const rtlCovertFn = (styleObj: dataType, isRtl?: boolean, isText?: boolean) => {
    const n = { ...styleObj };
    if (isText) {
        n.textAlign = n.textAlign || 'left';
    }
    if (isRtl) {
        Object.keys(n).forEach((key) => {
            if (rtlCovertAttrs[key]) {
                const coverAttr = rtlCovertAttrs[key];
                const tarVal = n[coverAttr];
                n[coverAttr] = styleObj[key];
                if (tarVal) {
                    n[key] = tarVal;
                } else {
                    delete n[key];
                }
            }
            if (key === 'textAlign' && ['left', 'right'].includes(n[key])) {
                const value = n[key] === 'left' ? 'right' : 'left';
                n[key] = value;
            }
        });
        return n;
    }
    return n;
};
export const rtlDirectionFn = (styleObj: dataType, isRtl): dataType => {
    const n = { ...styleObj };
    if (isRtl && n.flexDirection === 'row') {
        n.flexDirection = 'row-reverse';
    }
    return n;
};

let rootTagVar = '';
export const localStorage =
    Platform.OS === 'web'
        ? window.localStorage
        : {
              setRootTag: ({ rootTag }) => {
                  rootTagVar = rootTag;
              },
              getItem: (key: string) => {
                  const params = {
                      level: 'disk',
                      key,
                  };
                  return new Promise((resolve) => {
                      NativeModules.KrnBridge.getStorage(rootTagVar, params).then((res) => {
                          if (res.localString) {
                              resolve(res.localString);
                          } else {
                              if (Object.keys(res).length === 0) {
                                  return resolve(null);
                              }
                              resolve(res);
                          }
                      });
                  });
              },

              setItem: (key: string, value: any) => {
                  const params = {
                      level: 'disk',
                      key,
                      value,
                  };
                  if (typeof value === 'string') {
                      params.value = {
                          localString: value,
                      };
                  }
                  return NativeModules.KrnBridge.setStorage(rootTagVar, params);
              },
              removeItem: (key: string) => {
                  return NativeModules.KrnBridge.setStorage(rootTagVar, {
                      level: 'disk',
                      key,
                      value: {},
                  });
              },
          };

export const ifStyle = (condition, styleObj) => {
    return condition ? styleObj : '';
};

export const numberFont = {
    fontFamily: isAndroid ? 'roboto_black_1' : 'AlteDIN1451Mittelschrift',
};

export const classProps = (classNames) => {
    return isWeb
        ? {
              className: classNames,
          }
        : {
              style: classNames,
          };
};
